export default ['roles/owner'];
